import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './Brand.module.scss';

export interface IBrand {
  title: string;
  subtitle: string;
  logo: string;
  className?: string;
}

const Brand: FC<IBrand> = (props) => {
  const { title, subtitle, logo, className } = props;
  const rootClassName = classNames(styles.root, className);

  return (
    <section className={rootClassName}>
      <img src={logo} className={styles.logo} alt={`${title} logo`} width='79' height='40' />
      <div>
        <h2 className={styles.title}>{title}</h2>
        <h3 className={styles.subtitle}>{subtitle}</h3>
      </div>
    </section>
  );
};

export default Brand;
